export default __webpack_public_path__ + "static/media/splash-background.b2e05323.png";